"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBPART_L_NOT_ADOPTED = void 0;
exports.getEpisodicRelief = getEpisodicRelief;
const states_1 = require("encamp-shared/dist/constants/states");
const facilityState_1 = require("../facilityState");
/**
 * States whose programs do not grant the carve-out. Episodic generation is
 * RELIEF added by the 2016 Generator Improvements Rule, and a less-stringent
 * federal provision does not take effect in an authorized state until that
 * state adopts it (40 CFR 271.1(i)(2)) — so non-adoption is a real, per-state
 * fact rather than a quirk of two jurisdictions.
 *
 * The default this list implies — adopted everywhere it does not name — is
 * asserted by nobody yet and is the standing question for the waste SME. Kept
 * as one legible list precisely so the answer changes one line whichever way
 * it goes. See `EPISODIC_EXPECTATIONS`, which is the reviewable artifact.
 */
exports.SUBPART_L_NOT_ADOPTED = new Set([
    "CA",
    "MN",
]);
/**
 * The two facts the answer rests on, kept apart because they are unrelated:
 * a per-state ADOPTION fact, and a FEDERAL TIER rule identical everywhere.
 * Bundling them is what made this look like a property of a jurisdiction's
 * clock, which it is not.
 */
function getEpisodicRelief(query) {
    const state = (0, facilityState_1.parseFacilityState)(query.state);
    if (state !== null && exports.SUBPART_L_NOT_ADOPTED.has(state)) {
        // Spelled out, not abbreviated: this reason reaches the user as the create
        // form's warning, where "CA has not adopted…" reads like a code leak.
        const stateName = states_1.stateNamesByAbbreviation.get(state) ?? state;
        return {
            isAvailable: false,
            reason: `${stateName} has not adopted the federal episodic-generation relief (40 CFR 262 subpart L)`,
        };
    }
    if (query.generatorStatus === "LQG") {
        // Worded for the create form as much as for this file: the reason is what
        // the validator's warning shows the user.
        return {
            isAvailable: false,
            reason: "Episodic events are subpart L relief for VSQGs and SQGs — a large " +
                "quantity generator's 90-day clock already governs a surge",
        };
    }
    // Null status included: declaring an event is itself a subpart L act, and
    // withholding the window would report no deadline where the law imposes one.
    return { isAvailable: true };
}
//# sourceMappingURL=relief.js.map